import { connect } from 'react-redux';
import Recomende from '../components/RecomendeComponent';
import { sendMessage, setSuccessMessage } from '../actions/RecomendeAction';
import { setProfileModalState } from '../../profile/actions/ProfileActions';

const mapStateToProps = (state) => ({
    isLogged: !!state.profile.jwt,
    successMessage: state.recomende.successMessage,
    isSending: state.recomende.isSending,
});

const mapDispatchToProps = (dispatch) => ({
    sendMessage: (messageData) => {
        dispatch(sendMessage(messageData));
    },
    setModalState: (open) => {
        dispatch(setProfileModalState(open));
    },
    setSuccessMessage: (success) => {
        dispatch(setSuccessMessage(success));
    },
});


const RecomendeContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Recomende);

export default RecomendeContainer;
